<div class="hint-error" [tooltip]="tooltipHtml" [placement]="placement">
  <span class="fa-stack">
    <i class="fas fa-exclamation fa-stack-1x" style="color: tomato"></i>
    <i class="far fa-circle fa-stack-2x"></i>
  </span>
</div>

<ng-template #tooltipHtml>
  <div [innerHTML]="text"></div>
</ng-template>

